module.exports = __webpack_public_path__ + "media/explosion-2.e01dea0c.mp3";